<template>
  <div class="receptionOverflow">
    <div v-if="Lib.checkPower('beauty-3-ckpb',2)" class="flex">
      <div class="blockFive">
        <el-date-picker v-if="setCode == 0" v-model="value" type="month" placeholder="选择月" value-format="yyyy-MM" :clearable="false" :editable="false" @change="changeMonth"></el-date-picker>
        <el-button :class="setCode == 0 ? 'ml_20' : ''" type="primary" :disabled="saveScheduleBtn" @click="saveSchedule">保存排班</el-button>
        <el-button class="ml_20" type="primary" @click="addSchedule">添加班次</el-button>
      </div>
      <div style="width: 100%;">
        <div style="width: calc(100vw - 530px);float: left;">
          <div class="pbTable">
            <pl-table id="ceshiTable" ref="selectTable" v-loading="loading" tooltip-effect="light" use-virtual :data="tableData" border height="500" @row-click="selectRow" @header-click="selectColumn">
              <pl-table-column fixed="left" prop="technicianName" label="姓名/日期" width="100" :show-overflow-tooltip="true">
                <!-- <template slot-scope="scope">
                  <div style="height: 80px;display: grid;line-height: 80px;text-align: center;">{{scope.row.technicianName}}</div>
                </template> -->
              </pl-table-column>
              <pl-table-column v-for="(item,index) in weekFormat1" :key="index" :label="setCode == 0 ? ((index+1)+'\n'+item) : item" :width="setCode == 0 ?'80' : ''">
                <template slot-scope="scope">
                  <!-- <el-popover placement="bottom" width="110" trigger="manual">
                    <div style="padding: 12px;">
                      {{scope.row.technicianClassList[index].timeStr}}
                    </div> -->
                  <div style="min-width: 80px;height: 80px;display: grid;">
                    <div v-if="scope.row.technicianClassList[index].isOrder == -1" slot="reference" class="shiftOverdue" @click="editShift(scope.row.technicianClassList[index].index,index,scope.row.technicianClassList[index].scheduleTime,scope.row.technicianClassList[index].weekends)">{{ scope.row.technicianClassList[index].className }}</div>
                    <div v-if="scope.row.technicianClassList[index].isOrder == 0" slot="reference" class="shiftAvailable" @click="editShift(scope.row.technicianClassList[index].index,index,scope.row.technicianClassList[index].scheduleTime,scope.row.technicianClassList[index].weekends)">{{ scope.row.technicianClassList[index].className }}</div>
                    <div v-if="scope.row.technicianClassList[index].isOrder == 1" slot="reference" class="shiftIsOrder" @click="editShift(scope.row.technicianClassList[index].index,index,scope.row.technicianClassList[index].scheduleTime,scope.row.technicianClassList[index].weekends)">
                      <span class="shiftTitle" style="color: #f56c6c;">{{ scope.row.technicianClassList[index].className }}</span>
                      <!-- <i class="iconfont">&#xe66c;</i> -->
                    </div>
                    <div v-if="scope.row.technicianClassList[index].isOrder == 2" slot="reference" class="shiftIsOrder" @click="editShift(scope.row.technicianClassList[index].index,index,scope.row.technicianClassList[index].scheduleTime,scope.row.technicianClassList[index].weekends)">
                      <span class="shiftTitle">{{ scope.row.technicianClassList[index].className }}</span>
                      <i class="iconfont themeFC">&#xe66c;</i>
                    </div>
                  </div>
                  <!-- </el-popover> -->
                </template>
              </pl-table-column>
            </pl-table>
          </div>
        </div>
        <div style="float: right;">
          <div class="addShiftList">
            <h1>全部班次</h1>
            <div class="content">
              <div v-for="(item,index) in shiftListData" :key="index" :class="chooseShiftIndex == index ? 'list chooseList' : 'list'" @click="chooseAddShift(index)">
                <el-col :span="7">
                  <h2>{{ item.className }}</h2>
                </el-col>
                <el-col :span="12">
                  <h3 v-for="(items,v) in item.classItems" :key="v">{{ items.timeStart }}~{{ items.timeEnd }}</h3>
                </el-col>
                <el-col :span="5">
                  <p @click="editSchedule(index)">编辑</p>
                  <p @click="delSchedule(item.classId)">删除</p>
                </el-col>
                <i v-if="chooseShiftIndex == index" class="iconfont">&#xe66c;</i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="commonTitle" style="clear: both;margin-bottom: 20px;">
        <h1>班次汇总表</h1>
      </div>
      <div v-if="Lib.checkPower('beauty-4-ckbc',2)">
        <div v-if="setCode != 0" style="padding-bottom: 20px;">
          <el-date-picker v-model="value" type="month" placeholder="选择月" value-format="yyyy-MM" :clearable="false" :editable="false" @change="changeMonth('new')"></el-date-picker>
        </div>
        <div class="pbTable" style="margin-bottom: 20px;">
          <el-table :data="tableData2" border>
            <el-table-column prop="className" label="班次/日期" width="100">
            </el-table-column>
            <el-table-column v-for="(item,index) in weekFormat2" :key="index" :label="(index+1)+''" min-width="50">
              <template slot-scope="scope">
                <span style="height: 40px;display: block;line-height: 40px;">{{ scope.row.collectionItems[index].count }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
    </div>
    <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>

    <el-dialog width="800px" title="新增班次" :visible.sync="addShiftDialog" :append-to-body="true">
      <el-form ref="addForm" :model="addForm" label-width="140px" class="demo-ruleForm">
        <el-form-item label="班次名称：" prop="className" :rules="[{ required: true, message: '请输入班次名称', trigger: 'blur' },
                                                              { required: true, message: '请输入班次名称', trigger: 'change' },{ min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }]" required
        >
          <el-input v-model.trim="addForm.className" style="width: 455px;" placeholder="请输入班次名称" @keyup.enter.native="Lib.keyboardBlur"></el-input>
        </el-form-item>
        <el-form-item v-for="(item,index) in addForm.classItems" :key="index" label="班次时间：" required>
          <el-form-item style="float: left;" :prop="'classItems.'+index+'.timeStart'" :rules="[{ required: true, message: '请选择起始时间', trigger: 'change' }]">
            <el-time-select v-model="item.timeStart" placeholder="起始时间" :picker-options="{start: item.timeStart ? item.timeStart : '00:00',step: '00:30',end: '24:00',maxTime: item.timeEnd}" value-format="HH:mm" :disabled="addForm.classItems.length == (index+1) ? false : true">
            </el-time-select>
          </el-form-item>
          <span style="float: left;padding: 0 4px;">-</span>
          <el-form-item style="float: left;" :prop="'classItems.'+index+'.timeEnd'" :rules="[{ required: true, message: '请选择结束时间', trigger: 'change' }]">
            <el-time-select v-model="item.timeEnd" placeholder="结束时间" :picker-options="{start: '00:00',step: '00:30',end: '24:00',minTime: item.timeStart}" value-format="HH:mm" :disabled="addForm.classItems.length == (index+1) ? false : true">
            </el-time-select>
          </el-form-item>
          <el-button v-if="index !== 0" class="ml_20" type="danger" @click="delTimeList(index)">删除</el-button>
        </el-form-item>
        <el-form-item v-if="addForm.classItems.length < 5" label="">
          <p style="width: 455px;text-align: right;">
            <el-button type="text" @click="addTimeList">+继续添加时间段</el-button>
          </p>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" style="padding-right: 20px;">
        <el-button type="primary" @click="comfirmAddShift('addForm')">确 定</el-button>
        <el-button @click="addShiftDialog = false">取 消</el-button>
      </span>
    </el-dialog>

    <gt-delDig @delData="getDelData"></gt-delDig>
  </div>
</template>

<script>
import {
  getTechnicianClassList,
  postSaveOrUpdateClass,
  postTechnicianClass,
  getClassList
} from './api';

export default {
  data() {
    return {
      value: '', // 选择排班月份
      tableData: [], // 排班数据
      tableData2: [], // 班次汇总表
      weekFormat1: [], // 排班表
      weekFormat2: [], // 班次时间表
      nowMonthDays: '', // 月份的总天数
      weekList: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      nowWeek: '', // 当天为周几
      addShiftDialog: false, // 新增班次--弹出框
      addForm: { // 新增班次--表单数据
        id: '',
        className: '',
        classItems: [
          {
            timeStart: '',
            timeEnd: ''
          }
        ]
      },
      shiftListData: [], // 全部班次列表
      chooseShift: {}, // 选择班次
      chooseShiftIndex: '-1', // 选择班次index
      saveListData: [], // 保存班次数据--容器
      saveScheduleBtn: false, // 保存班次按钮状态
      delForm: { // 删除班次数据--公用组件
        delDiglogStatus: false,
        title: '',
        id: '',
        url: 'getDeleteClass',
        text1: '',
        text2: '',
        status: false
      },
      loading: false,
      setCode: 1, // 设置排班的展示方式  1按月  2按单周  3按双周
    };
  },
  // 监听添加/删除班次弹出框
  watch: {
    'delForm.delDiglogStatus': function (val) {
      if (val == false) {
        this.getShiftListData();
      }
    },
    'delForm.status': function (val) {
      if (val == true) {
        this.chooseShiftIndex = '-1';
        this.chooseShift = {};
      }
    },
    addShiftDialog(val) {
      if (val == false) {
        this.getShiftListData();
      }
    }
  },
  activated() {
    const today = new Date();
    this.value = this.Lib.D(today.getTime(), 'yyyy-MM');
    this.changeMonth();
    this.getShiftListData();
  },
  methods: {
    // 选择月份
    changeMonth(val) {
      const data = {
        month: this.value
      };
      this.loading = true;
      if (val !== 'new') {
        this.tableData = [];
      }
      this.tableData2 = [];
      getTechnicianClassList(data).then((res) => {
        this.saveListData = [];
        if (val !== 'new') {
          this.tableData = res.data.technicianClassDtoList;
        }
        this.tableData2 = res.data.erpClassCollectionList;
        const newDate = new Date();
        if (this.value.substring(0, 4) == newDate.getFullYear() && (this.value.substring(5, 7) * 1) == (newDate.getMonth() * 1 + 1) && this.setCode == 0) {
          $('#ceshiTable .el-table__body-wrapper').scrollLeft(newDate.getDate() * 80 - 80);
        } else {
          $('#ceshiTable .el-table__body-wrapper').scrollLeft(0);
        }
        const date = `${this.value}-01`;
        const day = new Date(Date.parse(date));
        // eslint-disable-next-line no-array-constructor
        const nowDay = new Array('0', '1', '2', '3', '4', '5', '6');
        const week = nowDay[day.getDay()];
        this.nowWeek = week;
        this.setCode = res.data.classType;
        this.numberOfDays(this.value.substring(0, 4), this.value.substring(5, 7));
        if (this.setCode == 1) {
          this.chooseOneCycle();
        } else if (this.setCode == 2) {
          this.chooseBiweekly();
        }
        this.loading = false;
      });
    },
    // 添加班次
    addSchedule() {
      if (this.Lib.checkPower('beauty-4-tjbc') == false) return;
      this.addShiftDialog = true;
      this.addForm = {
        id: '',
        className: '',
        classItems: [
          {
            timeStart: '',
            timeEnd: ''
          }
        ]
      };
      this.$refs.addForm.resetFields();
    },
    // 修改班次
    editSchedule(index) {
      if (this.Lib.checkPower('beauty-4-bjbc') == false) return;
      this.addShiftDialog = true;
      this.addForm = this.shiftListData[index];
    },
    // 删除班次
    delSchedule(id) {
      if (this.Lib.checkPower('beauty-4-scbc') == false) return;
      this.delForm.delDiglogStatus = true;
      this.delForm.id = id;
      this.delForm.title = '提示';
      this.delForm.url = 'getDeleteClass';
      this.delForm.text1 = '确定要删除这条班次吗？';
      this.delForm.text2 = '删除后，不会删除此班次相关数据';
      this.delForm.status = false;
    },
    // 添加时间段
    addTimeList() {
      let status = 0;
      this.addForm.classItems.forEach((v) => {
        if (!v.timeStart || !v.timeEnd) {
          status = 1;
        }
      });
      if (status == 1) {
        this.$message('请填写完当前班次时间');
        return;
      }
      const index = this.addForm.classItems.length * 1 - 1;
      const addTime = {
        timeStart: this.addForm.classItems[index].timeEnd,
        timeEnd: ''
      };
      this.addForm.classItems.push(addTime);
    },
    // 删除时间段
    delTimeList(index) {
      this.addForm.classItems.splice(index, 1);
    },
    // 选择班次
    chooseAddShift(index) {
      this.chooseShiftIndex = index;
      this.chooseShift = this.shiftListData[index];
    },
    // 确定添加班次
    comfirmAddShift(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const data = this.addForm;
          postSaveOrUpdateClass(data).then((res) => {
            if (res.code == 0) {
              vm.addShiftDialog = false;
              vm.$message({ message: '添加/修改成功', type: 'success' });
              vm.getShiftListData();
            } else {
              vm.$message({ message: res.msg, type: 'error' });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改班次
    editShift(column, index, time, weekends) {
      const vm = this;
      if (vm.chooseShiftIndex == '-1') {
        vm.$message('请先在右侧选择排次，再进行设置');
        return;
      } if (
        vm.tableData[column].technicianClassList[index].isOrder == -1
      ) {
        vm.$message.warning('不能设置当天之前的排班');
        return;
      } if (
        vm.tableData[column].technicianClassList[index].isOrder == 1
      ) {
        vm.$message.warning('当前排班有预约，不能修改');
        return;
      }
      vm.tableData[column].technicianClassList[index].classId = vm.chooseShift.classId;
      const obj = {};
      obj.classId = vm.chooseShift.classId;
      obj.className = vm.chooseShift.className;
      obj.classType = vm.setCode;
      obj.scheduleTime = time;
      obj.technicianClassId = vm.tableData[column].technicianClassList[index]
        .technicianClassId
        ? vm.tableData[column].technicianClassList[index].technicianClassId
        : '';
      if (
        vm.tableData[column].technicianClassList[index].classId
        == vm.chooseShift.classId
        && vm.tableData[column].technicianClassList[index].className
        == vm.chooseShift.className
      ) {
        obj.technicianClassItems = [];
        vm.tableData[column].technicianClassList[index].isOrder = 0;
        vm.tableData[column].technicianClassList[index].className = '';
      } else {
        obj.technicianClassItems = vm.chooseShift.classItems;
        vm.tableData[column].technicianClassList[index].isOrder = 2;
        vm.tableData[column].technicianClassList[index].className = vm.chooseShift.className;
      }
      obj.technicianId = vm.tableData[column].technicianClassList[index].technicianId;
      obj.weekends = weekends;
      let saveNum = 0;
      vm.saveListData.forEach((c) => {
        if (vm.setCode == 0) {
          if (c.technicianId == obj.technicianId && c.scheduleTime == obj.scheduleTime) {
            c.classId = obj.classId;
            c.className = obj.className;
            c.technicianClassId = obj.technicianClassId;
            c.technicianClassItems = obj.technicianClassItems;
          } else {
            saveNum++;
          }
        } else if (c.technicianId == obj.technicianId && c.weekends == obj.weekends) {
          c.classId = obj.classId;
          c.className = obj.className;
          c.technicianClassId = obj.technicianClassId;
          c.technicianClassItems = obj.technicianClassItems;
        } else {
          saveNum++;
        }
      });
      if (vm.saveListData.length == saveNum) {
        vm.saveListData.push(obj);
      }
      // console.log(vm.saveListData)
    },
    // 选择行
    selectRow(row, column) {
      const vm = this;
      if (column.label !== '姓名/日期') return;
      vm.tableData.forEach((a) => {
        if (a.id == row.id) {
          if (vm.chooseShiftIndex == '-1') {
            vm.$message('请先在右侧选择排次，再进行设置');
            return;
          }
          let cNum = 0;
          row.technicianClassList.forEach((e) => {
            if ((e.classId != vm.chooseShift.classId || e.className != vm.chooseShift.className) && e.isOrder != -1 && e.isOrder != 1) {
              cNum = 1;
            }
          });
          row.technicianClassList.forEach((b) => {
            if (b.isOrder == -1) {
              return;
            } if (b.isOrder == 1) {
              return;
            }
            b.classId = vm.chooseShift.classId;
            const obj = {};
            obj.classId = vm.chooseShift.classId;
            obj.className = vm.chooseShift.className;
            obj.classType = vm.setCode;
            obj.scheduleTime = b.scheduleTime;
            obj.technicianClassId = b.technicianClassId ? b.technicianClassId : '';
            if (cNum == 1) {
              obj.technicianClassItems = vm.chooseShift.classItems;
              b.isOrder = 2;
              b.className = vm.chooseShift.className;
            } else {
              obj.technicianClassItems = [];
              b.isOrder = 0;
              b.className = '';
            }
            obj.technicianId = b.technicianId;
            obj.weekends = b.weekends;
            let saveNum = 0;
            vm.saveListData.forEach((c) => {
              if (vm.setCode == 0) {
                if (c.technicianId == obj.technicianId && c.scheduleTime == obj.scheduleTime) {
                  c.classId = obj.classId;
                  c.className = obj.className;
                  c.technicianClassId = obj.technicianClassId;
                  c.technicianClassItems = obj.technicianClassItems;
                } else {
                  saveNum++;
                }
              } else if (c.technicianId == obj.technicianId && c.weekends == obj.weekends) {
                c.classId = obj.classId;
                c.className = obj.className;
                c.technicianClassId = obj.technicianClassId;
                c.technicianClassItems = obj.technicianClassItems;
              } else {
                saveNum++;
              }
            });
            if (vm.saveListData.length == saveNum) {
              vm.saveListData.push(obj);
            }
          });
        }
      });
    },
    // 选择列
    selectColumn(column) {
      const vm = this;
      const val = vm.getCaption(column.label, vm.setCode);
      if (vm.chooseShiftIndex == '-1') {
        vm.$message('请先在右侧选择排次，再进行设置');
        return;
      }
      if (val) {
        console.log(vm.tableData);
        let cNum = 0;
        vm.tableData.forEach((a) => {
          a.technicianClassList.forEach((e, m) => {
            if ((e.classId != vm.chooseShift.classId || e.className != vm.chooseShift.className) && e.isOrder != -1 && e.isOrder != 1 && (val == (m + 1))) {
              cNum = 1;
            }
          });
        });
        vm.tableData.forEach((a) => {
          a.technicianClassList.forEach((b, n) => {
            if (b.isOrder == -1) {
              return;
            } if (b.isOrder == 1) {
              return;
            }
            if (val != (n + 1)) {
              return;
            }
            b.classId = vm.chooseShift.classId;
            const obj = {};
            obj.classId = vm.chooseShift.classId;
            obj.className = vm.chooseShift.className;
            obj.classType = vm.setCode;
            obj.scheduleTime = b.scheduleTime;
            obj.technicianClassId = b.technicianClassId ? b.technicianClassId : '';
            if (cNum == 1) {
              obj.technicianClassItems = vm.chooseShift.classItems;
              b.isOrder = 2;
              b.className = vm.chooseShift.className;
            } else {
              obj.technicianClassItems = [];
              b.isOrder = 0;
              b.className = '';
            }
            obj.technicianId = b.technicianId;
            obj.weekends = b.weekends;
            let saveNum = 0;
            vm.saveListData.forEach((c) => {
              if (vm.setCode == 0) {
                if (c.technicianId == obj.technicianId && c.scheduleTime == obj.scheduleTime) {
                  c.classId = obj.classId;
                  c.className = obj.className;
                  c.technicianClassId = obj.technicianClassId;
                  c.technicianClassItems = obj.technicianClassItems;
                } else {
                  saveNum++;
                }
              } else if (c.technicianId == obj.technicianId && c.weekends == obj.weekends) {
                c.classId = obj.classId;
                c.className = obj.className;
                c.technicianClassId = obj.technicianClassId;
                c.technicianClassItems = obj.technicianClassItems;
              } else {
                saveNum++;
              }
            });
            if (vm.saveListData.length == saveNum) {
              vm.saveListData.push(obj);
            }
          });
        });
      }
    },
    // 筛选
    getCaption(val, state) {
      let obj = val;
      // eslint-disable-next-line no-useless-escape
      const index = obj.lastIndexOf('\星期');
      if (state == 0) {
        obj = obj.substring(0, index);
      } else {
        const map = {
          周日: 1,
          周一: 2,
          周二: 3,
          周三: 4,
          周四: 5,
          周五: 6,
          周六: 7,
          次周日: 8,
          次周一: 9,
          次周二: 10,
          次周三: 11,
          次周四: 12,
          次周五: 13,
          次周六: 14
        };
        obj = map[obj];
      }
      return obj;
    },
    // 保存排班
    saveSchedule() {
      const vm = this;
      if (vm.Lib.checkPower('beauty-3-szpb') == false) return;
      const arr = vm.saveListData;
      if (arr.length == 0) {
        vm.$message('请选择排班');
        return;
      }
      vm.saveScheduleBtn = true;
      const data = {
        erpTechnicianClassDto: arr
      };
      postTechnicianClass(data).then((res) => {
        if (res.code == 0) {
          vm.$message({ message: '保存排班成功', type: 'success' });
          vm.changeMonth();
        } else {
          vm.$message(res.msg);
        }
        vm.saveScheduleBtn = false;
      });
    },
    // 计算每月的天数
    numberOfDays(y, m) {
      const vm = this;
      if ((m == 2 && y % 4 == 0 && y % 100 != 100) || y % 400 == 0) {
        vm.nowMonthDays = 29;
      } else if (m == 2 && y % 4 != 0) {
        vm.nowMonthDays = 28;
      } else if (m == 1 || m == 3 || m == 5 || m == 7 || m == 8 || m == 10 || m == 12) {
        vm.nowMonthDays = 31;
      } else if (m == 2 || m == 4 || m == 6 || m == 9 || m == 11) {
        vm.nowMonthDays = 30;
      }
      vm.weekFormat2 = [];
      for (let i = vm.nowWeek; vm.nowMonthDays * 1 + vm.nowWeek * 1 > i; i++) {
        const map = {
          0: '星期日', 1: '星期一', 2: '星期二', 3: '星期三', 4: '星期四', 5: '星期五', 6: '星期六'
        };
        vm.weekFormat2.push(map[i % 7]);
      }
      if (vm.setCode == 0) {
        vm.weekFormat1 = [];
        for (let j = vm.nowWeek; vm.nowMonthDays * 1 + vm.nowWeek * 1 > j; j++) {
          const map = {
            0: '星期日', 1: '星期一', 2: '星期二', 3: '星期三', 4: '星期四', 5: '星期五', 6: '星期六'
          };
          vm.weekFormat1.push(map[j % 7]);
          vm.$nextTick(() => {
            vm.$refs.selectTable.doLayout();
          });
        }
      }
    },
    // 选择单周
    chooseOneCycle() {
      const vm = this;
      vm.weekFormat1 = [];
      for (let i = 0; i < 7; i++) {
        const map = {
          0: '周日', 1: '周一', 2: '周二', 3: '周三', 4: '周四', 5: '周五', 6: '周六',
        };
        vm.weekFormat1.push(map[i % 7]);
      }
    },
    // 选择双周
    chooseBiweekly() {
      const vm = this;
      vm.weekFormat1 = [];
      for (let i = 0; i < 14; i++) {
        const map = {
          0: '周日',
          1: '周一',
          2: '周二',
          3: '周三',
          4: '周四',
          5: '周五',
          6: '周六',
          7: '次周日',
          8: '次周一',
          9: '次周二',
          10: '次周三',
          11: '次周四',
          12: '次周五',
          13: '次周六'
        };
        vm.weekFormat1.push(map[i % 14]);
      }
    },
    // 获取班次列表
    getShiftListData() {
      const data = {};
      getClassList(data).then((res) => {
        if (res.code == 0) {
          this.shiftListData = res.data;
        } else {
          // console.log(res);
        }
      });
    },
    // 调用公共组件--赋值
    getDelData(list) {
      this.delForm = list;
    }
  }
};
</script>

<style>
.pbTable .el-table .cell {
  white-space: pre-wrap !important;
  text-align: center !important;
  padding: 0 !important;
}
.pbTable .el-table td,
.el-table th {
  padding: 0 !important;
}
.pbTable .el-table thead tr:first-child {
  background-color: #eef1f6;
  color: #818691;
  font-size: 13.5px;
}
.pbTable .el-table .has-gutter .cell {
  background-color: #eef1f6;
  font-size: 14px;
  color: #1f2d3d;
  font-weight: 600;
}
.pbTable .el-table .has-gutter td,
.el-table th {
  padding: 12px 0 !important;
  background-color: #eef1f6 !important;
}
.pbTable .el-table th.gutter {
  display: none !important;
  width: 0 !important;
}
.el-table--enable-row-transition .el-table__body td {
  width: 80px !important;
}
.pbTable .shiftOverdue {
  display: block;
  height: 80px;
  line-height: 80px;
  background-color: #f9fafc;
  color: #ddd;
}
.pbTable .shiftAvailable {
  display: block;
  height: 80px;
  line-height: 80px;
  background-color: #fff;
  color: #333;
  cursor: pointer;
}
.pbTable .shiftIsOrder {
  display: block;
  height: 80px;
  line-height: 80px;
  background-color: #fff;
  color: #333;
  cursor: pointer;
}
.pbTable .shiftIsOrder .shiftTitle {
  height: 60px;
  line-height: 80px;
}
.pbTable .shiftIsOrder .iconfont {
  display: block;
  font-family: "iconfont" !important;
  font-size: 22px;
  font-style: normal;
  width: 80px;
  height: 20px;
  line-height: 26px;
  position: absolute;
  margin: -20px 0 0 1px;
  text-align: right;
}
.addShiftList {
  border: 1px solid #e6ebf5;
  height: 500px;
  width: 308px;
}
.addShiftList h1 {
  height: 40px;
  color: #333;
  font-size: 14px;
  padding-left: 30px;
  background-color: #eef1f6;
  line-height: 40px;
}
.addShiftList .content {
  overflow-x: hidden;
  overflow-y: scroll;
  height: 440px;
  padding-bottom: 20px;
}
.addShiftList .content .list {
  margin: 20px 30px 0 30px;
  background-color: #f9fafc;
  min-height: 40px;
  padding: 20px;
  line-height: 20px;
  cursor: pointer;
}
.addShiftList .content .list:after {
  display: table;
  clear: both;
  content: "";
}
.addShiftList .content .list h2 {
  color: #999;
  font-size: 16px;
  font-weight: 600;
  min-height: 40px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.addShiftList .content .list h3 {
  color: #333;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
}
.addShiftList .content .list p {
  font-size: 14px;
  text-align: right;
  cursor: pointer;
}
.addShiftList .content .list p:hover {
  color: #ff4949;
}
.addShiftList .content .list .iconfont {
  font-family: "iconfont" !important;
  font-size: 22px;
  font-style: normal;
  width: 100%;
  text-align: right;
  height: 20px;
  content: "";
  clear: both;
  display: table;
  position: relative;
  right: -21px;
  top: 2px;
}
.addShiftList .content .chooseList {
  background-color: #e8f3ff;
  padding: 20px 20px 0 20px;
}

.addShiftList .content::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: #f5f5f5;
}
.addShiftList .content::-webkit-scrollbar-track-piece {
  background-color: #fff;
}
.addShiftList .content::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.addShiftList .content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #999;
}
.pbTable .el-table--enable-row-transition .el-table__body td {
  width: 0 !important;
}
.pbTable .el-table_1_column_1 {
  cursor: pointer;
}
.pbTable .has-gutter {
  cursor: pointer;
}
.pbTable .el-table td {
  border-bottom: 1px solid #EBEEF5;
  border-right: 1px solid #EBEEF5;
}
#ceshiTable .pl-table-beyond {
  height: 80px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}
</style>
